import React, { useState, useEffect } from 'react';
import { updateBodyClass } from '../../utils/function';
import { EmailResetLink } from '../../utils/apicall/ResetPasswordApi';

const ResetPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  // Add specific class to body on component mount
  useEffect(() => {
    document.title = 'Ξέχασες τον Κωδικό?'; // Set the title of the page
    updateBodyClass('auth-page');
    return () => {
      document.title = ''; // Reset title on unmount
      updateBodyClass('');
    };
  }, []);

  // Function to validate email format
  const validateEmail = (email: string): boolean => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!email) {
      setEmailError('Το email είναι υποχρεωτικό.');
      return;
    }

    if (!validateEmail(email)) {
      setEmailError('Παρακαλώ εισάγετε έγκυρο email.');
      return;
    }
    console.log(email);
  try {
      const response = await EmailResetLink(email);
    
      console.log(response);
    
    } catch (error) {
      console.error('Email επαναφορά κωδικού: ', error);
      // Optionally, set an error message if needed
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center animated-fade">
        <div className="card p-5">
          {/* Title and Subtitle */}
          <div className="text-center mb-4">
            <h2 className="welcome-text">Ξέχασες τον Κωδικό;</h2>
            <p className="sub-text">Εισάγετε το email σας για να λάβετε οδηγίες επαναφοράς.</p>
          </div>

          <form onSubmit={handleSubmit}>
            {/* Email Input */}
            <div className="mb-4">
              <label htmlFor="email" className="form-label visually-hidden">Email</label>
              <div className="input-group">
                <span className="input-group-text"><i className="bi bi-envelope"></i></span>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError(''); // Reset error on change
                  }}
                  required
                />
              </div>
              {emailError && <small className="text-danger">{emailError}</small>}
            </div>

            {/* Submit Button */}
            <div className="d-grid">
              <button type="submit" className="btn btn-custom btn-lg">Αποστολή</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
